import script from "./VisualVoiceEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualVoiceEditor.vue?vue&type=script&setup=true&lang=js"

import "./VisualVoiceEditor.vue?vue&type=style&index=0&id=295822a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-295822a1"]])

export default __exports__